/**
 * championKitBootAssassin — Zed / Katarina dispatchers (SPY-610).
 */
import { registerChampionDispatcher } from './abilityDispatcher.js';
import {
  castZedQ, castZedW, castZedE, castZedR
} from '../domain/champions/zed.js';
import {
  castKatarinaQ, castKatarinaW, castKatarinaE, castKatarinaR
} from '../domain/champions/katarina.js';

export const SPY610_ASSASSIN_KEYS = ['zed', 'katarina'];

registerChampionDispatcher('zed', {
  Q(player, worldPos, _projectiles, gameTime) {
    const bucket = [];
    if (!castZedQ(player, worldPos.x, worldPos.y, bucket, gameTime)) return null;
    return { type: 'zed_q', projectiles: bucket, cooldown: 6.0 };
  },
  W(player, worldPos) {
    if (!castZedW(player, worldPos.x, worldPos.y)) return null;
    return { type: 'zed_w', projectiles: [], cooldown: 20.0 };
  },
  E(player, _worldPos, _projectiles, _gameTime, entities) {
    if (!castZedE(player, entities)) return null;
    return { type: 'zed_e', projectiles: [], cooldown: 5.0 };
  },
  R(player, _worldPos, _projectiles, _gameTime, _entities, selectedTarget) {
    if (!selectedTarget) return null;
    if (!castZedR(player, selectedTarget)) return null;
    return { type: 'zed_r', projectiles: [], cooldown: 120.0 };
  }
});

registerChampionDispatcher('katarina', {
  Q(player, _worldPos, _projectiles, _gameTime, entities, selectedTarget) {
    if (!selectedTarget) return null;
    if (!castKatarinaQ(player, selectedTarget, entities)) return null;
    return { type: 'katarina_q', projectiles: [], cooldown: 11.0 };
  },
  W(player) {
    if (!castKatarinaW(player)) return null;
    return { type: 'katarina_w', projectiles: [], cooldown: 15.0 };
  },
  E(player, worldPos) {
    if (!castKatarinaE(player, worldPos.x, worldPos.y)) return null;
    return { type: 'katarina_e', projectiles: [], cooldown: 12.0 };
  },
  R(player, _worldPos, _projectiles, _gameTime, entities) {
    if (!castKatarinaR(player, entities)) return null;
    return { type: 'katarina_r', projectiles: [], cooldown: 75.0 };
  }
});
